import { Grid } from '@mui/material';
import { UserRoles } from 'services/api';
import { LabelText } from 'src/components/Employee/constants';
import { EmployeePage } from 'src/components/Employee/types';
import { EmployeeDetailForm } from 'src/components/Forms/EmployeeDetailForm/EmployeeDetailForm';
import { EmployeeDetailFormValues } from 'src/components/Forms/EmployeeDetailForm/types';
import { RadioGroup } from 'src/components/RadioGroup';

export const AddEmployee = (props: EmployeePage) => {
  const {
    config,
    detailFormRef,
    employeeRole,
    setEmployeeRole,
    buttons,
    ...others
  } = props;

  const initialFormValues: EmployeeDetailFormValues = {
    first_name: '',
    last_name: '',
    email: '',
    mobile_country_code: '',
    mobile_number: '',
    role: UserRoles.User,
    department_id: '',
    cost_center_id: 0,
    employee_code: '',
    expense_codes: [],
    is_eligible_for_all_expense_codes: false
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RadioGroup<UserRoles>
          name="role"
          label="User Role*"
          value={employeeRole}
          onChange={(value) => setEmployeeRole(value)}
          radioProps={[
            { label: LabelText.EMPLOYEE_ROLE.USER, value: UserRoles.User },
            { label: LabelText.EMPLOYEE_ROLE.MANAGER, value: UserRoles.Manager }
          ]}
        />
      </Grid>
      <Grid item>
        <EmployeeDetailForm
          initialValues={initialFormValues}
          countryCode={config.code}
          isNewUser={true}
          isForRightDrawer={true}
          detailFormRef={detailFormRef}
          buttons={buttons}
          {...others}
        />
      </Grid>
    </Grid>
  );
};
